import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { PlatformDemoLinkCard } from "./-components/platform-demo-link-card";
import { PlatformOutboundEmailCard } from "./-components/platform-outbound-email-card";
import { PlatformSignupSmsCard } from "./-components/platform-signup-sms-card";
import { PlatformSupportInboxCard } from "./-components/platform-support-inbox-card";
import { PlatformTermsUpdateCard } from "./-components/platform-terms-update-card";

export const Route = createFileRoute("/_authenticated/platform_/settings")({
  beforeLoad: ({ context }) => guardRoute(context.me, "platform-settings"),
  component: PlatformSettings,
});

/** What the whole platform sends and where its mail lands, beside the member's own profile. */
function PlatformSettings() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Platform settings"
        meta="How the whole platform reaches people: email, signup texts, the support inbox, the demo link and Terms updates."
      />
      <PlatformOutboundEmailCard />
      <PlatformSignupSmsCard />
      <PlatformSupportInboxCard />
      <PlatformDemoLinkCard />
      <PlatformTermsUpdateCard />
    </div>
  );
}
